import { CATEGORY_GROUP_KEYS, REFERENCE_GROUP_KEYS } from '@/config/router/routerMapConfig'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export default function useNavigation() {
	const { t: $t } = useI18n()

	const categoryGroups = computed(() => {
		return {
			[CATEGORY_GROUP_KEYS.DEVELOP]: {
				value: CATEGORY_GROUP_KEYS.DEVELOP,
				title: $t('Develop'),
			},

			[CATEGORY_GROUP_KEYS.PLANNING]: {
				value: CATEGORY_GROUP_KEYS.PLANNING,
				title: $t('Planning'),
			},

			[CATEGORY_GROUP_KEYS.WORKS]: {
				value: CATEGORY_GROUP_KEYS.WORKS,
				title: $t('Works'),
			},

			[CATEGORY_GROUP_KEYS.CAR_PARK]: {
				value: CATEGORY_GROUP_KEYS.CAR_PARK,
				title: $t('Car park'),
			},

			[CATEGORY_GROUP_KEYS.REPORTS]: {
				value: CATEGORY_GROUP_KEYS.REPORTS,
				title: $t('Reports'),
			},

			[CATEGORY_GROUP_KEYS.REAL_ESTATE]: {
				value: CATEGORY_GROUP_KEYS.REAL_ESTATE,
				title: $t('Real estate'),
			},
		}
	})

	const referenceGroups = computed(() => {
		return {
			[REFERENCE_GROUP_KEYS.INFRASTRUCTURE]: {
				value: REFERENCE_GROUP_KEYS.INFRASTRUCTURE,
				title: $t('menu.infrastructure'),
			},

			[REFERENCE_GROUP_KEYS.STAFF_DEPARTMENTS]: {
				value: REFERENCE_GROUP_KEYS.STAFF_DEPARTMENTS,
				title: $t('menu.Staff'),
			},

			[REFERENCE_GROUP_KEYS.RESOURCES]: {
				value: REFERENCE_GROUP_KEYS.RESOURCES,
				title: $t('menu.resources'),
			},

			[REFERENCE_GROUP_KEYS.CAR_PARK]: {
				value: REFERENCE_GROUP_KEYS.CAR_PARK,
				title: $t('menu.carPark'),
			},

			[REFERENCE_GROUP_KEYS.COUNTERPARTIES]: {
				value: REFERENCE_GROUP_KEYS.COUNTERPARTIES,
				title: $t('menu.counterparties'),
			},

			[REFERENCE_GROUP_KEYS.NORMS]: {
				value: REFERENCE_GROUP_KEYS.NORMS,
				title: $t('menu.norms'),
			},

			[REFERENCE_GROUP_KEYS.LAND_BANK]: {
				value: REFERENCE_GROUP_KEYS.LAND_BANK,
				title: $t('menu.landBank'),
			},

			[REFERENCE_GROUP_KEYS.FINANCES]: {
				value: REFERENCE_GROUP_KEYS.FINANCES,
				title: $t('menu.finances'),
			},

			[REFERENCE_GROUP_KEYS.WORKS]: {
				value: REFERENCE_GROUP_KEYS.WORKS,
				title: $t('menu.works'),
			},
		}
	})

	return {
		categoryGroups,
		referenceGroups,
	}
}
